import React from "react";
import { useNavigate } from "react-router-dom";
import UploadForm from "./UploadForm";
import videoSrc from "../assets/video/tanitim2.mp4";
import videoSrc2 from "../assets/video/tanıtım 2.mp4";
import '../style/ContestPage.css'

function ContestPage() {
  const navigate = useNavigate();

  return (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      <h1>Enerji Tasarrufu Yarışması</h1>
      <p>Aralık ve Ocak faturalarınızı yükleyerek yarışmaya katılabilirsiniz!</p>

      {/* Bilgilendirme Videosu */}
      <div style={{ margin: "20px 0" }}>
        <h2>Yarışmaya Nasıl Katılacağınızı Öğrenin</h2>
        <video
          width="600"
          controls
          style={{ border: "2px solid #ccc", marginTop: "10px" }}
        >
          <source src={videoSrc2} type="video/mp4" />
          Tarayıcınız bu videoyu desteklemiyor.
          <a href="tanitim2.mp4" target="_blank" rel="noreferrer">
            Buradan izleyebilirsiniz.
          </a>
        </video>

        <h2>Sayfa ile ilgili sorunlar için İletişim: 5364532478</h2>
        <video
          width="600"
          controls
          style={{ border: "2px solid #ccc", marginTop: "10px" }}
        >
          <source src={videoSrc} type="video/mp4" />
          Tarayıcınız bu videoyu desteklemiyor.
          <a href="tanıtım 2.mp4" target="_blank" rel="noreferrer">
            Buradan izleyebilirsiniz.
          </a>
        </video>
      </div>

      {/* Başvurular Butonu */}
      <button
        style={{
          padding: "10px 20px",
          margin: "20px",
          backgroundColor: "#007bff",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
        }}
        onClick={() => navigate("/applications")}
      >
        Başvurular
      </button>
      <button
        style={{
          padding: "10px 20px",
          margin: "20px",
          backgroundColor: "#007bff",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
        }}
        onClick={() => navigate("/results/:studentId")}
      >
        Sonuçlar
      </button>

      {/* Aralık ve Ocak Faturası Yükleme Formları */}
      <hr />
      <UploadForm isJanuary={false} />
      <hr />
      {/* <UploadForm isJanuary={true} /> */}
    </div>
  );
}

export default ContestPage;
